import { Component, computed, ElementRef, HostListener, inject, signal } from "@angular/core";
import { NgGlyph } from "@ng-icons/core";
import { Router } from "@angular/router";
import { AppButtonComponent } from "../../Components/Button/ButtonComponent";
import { AppAvatarComponent } from "../../Components/Avatar/AvatarComponent";
import { AuthEffects } from "../../../Modules/Auth/State/AuthEffects";
import { AuthState } from "../../../Modules/Auth/State/AuthState";
import { User } from "../../../Modules/Auth/Dto/UserModel";

@Component({
  selector: "app-topbar-layout",
  standalone: true,
  imports: [NgGlyph, AppButtonComponent, AppAvatarComponent],
  templateUrl: "./TopbarLayout.html",
  styleUrl: "./TopbarLayout.scss",
})
export class TopbarLayout {
  private readonly authState = inject(AuthState);
  private readonly authEffects = inject(AuthEffects);
  private readonly elementRef = inject(ElementRef);
  private readonly router = inject(Router);

  readonly isMenuOpen = signal(false);
  readonly user = computed<User>(() => {
    const user = this.authState.user();

    if (!user) {
      throw new Error("Authenticated user is missing.");
    }

    return user;
  });

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.isMenuOpen()) {
      return;
    }

    const target = event.target as Node | null;
    if (target && this.elementRef.nativeElement.contains(target)) {
      return;
    }

    this.isMenuOpen.set(false);
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.isMenuOpen.update((open) => !open);
  }

  async profile() {
    this.isMenuOpen.set(false);
    await this.router.navigate(["/profile"]);
  }

  logout() {
    this.isMenuOpen.set(false);
    this.authEffects.logout();
  }
}
